import React from 'react';

const MonitorRealTimeResources = () => {
  return <div>Monitor Real Time Resources</div>;
};

export default MonitorRealTimeResources;